import httpService from '@/core/http-service'
import store from '@/store'
import _ from 'lodash'

function get(resource) {
  return httpService.get(resource)
}

function create(type, data = {}) {
  const template = store.getters.templates[type]
  if(template) {
    return _.merge(_.cloneDeep(template), data)
  }
  throw new Error(`entity template ${type} not found`)
}

export default { get, create }
